import type { ComponentType } from 'react';

import { useLiveRendering } from '../hooks';

export function withLiveRendering(App: ComponentType<AppProps>) {
  return function LiveRenderingApp(props: AppProps) {
    const {
      enabled,
      loading,
      contentUrl,
      globalUrl,
      themeUrl,
      customCssUrl,
      fontsUrl,
      configModifier,
    } = useLiveRendering();

    if (enabled && loading) {
      return null;
    }

    return (
      <App
        {...props}
        contentUrl={contentUrl}
        globalUrl={globalUrl}
        themeUrl={themeUrl}
        customCssUrl={customCssUrl}
        fontsUrl={fontsUrl}
        configModifier={configModifier as AppProps['configModifier']}
      />
    );
  };
}
